import { Component, OnInit } from '@angular/core';
import { ServiceStock } from '../service-stock.service';

declare let $: any;

@Component({
  selector: 'app-setup-password',
  templateUrl: './setup-password.component.html',
  styleUrls: ['./setup-password.component.scss']
})
export class SetupPasswordComponent implements OnInit {

  newPassword: any;
  confirmPassword: any;
  passwordValid: boolean = false;
  userName:any;
  proceed:boolean = false;
  cPassErrMsg:string = "";

  constructor(private services:ServiceStock) { }

  ngOnInit() {
    this.userName = this.services.dataStore.getData("mobileNumber").split(" ")[1];
  }

  validateConfirmPass(){
    var nPassword = this.newPassword;
    var cPassword = this.confirmPassword;

    this.cPassErrMsg = '';
    if(nPassword.substr(0, cPassword.length) != cPassword){
      this.proceed = false;
      this.cPassErrMsg = "Confirm password does not match with new password";
    }else{
      if(this.passwordValid && nPassword == cPassword){
        this.proceed = true;
      }else{
        this.proceed = false;
      }
    }
  }

  validatePassword() {
    var password = this.newPassword;

    var username = this.userName; //TODO: set phone number
    var usernameMatch = $("#usernameMatch");
    var letter = $("#letter");
    var capital = $("#capital");
    var number = $("#number");
    var length = $("#length");
    var char = $("#char");

    // Validate lowercase letters
    var lowerCaseLetters = /[a-z]/g;
    if (password.match(lowerCaseLetters)) {
      console.log('working low');
      letter.removeClass("txt-danger");
      letter.addClass("txt-success");
    } else {
      letter.removeClass("txt-success");
      letter.addClass("txt-danger");
    }

    // Validate uppercase letters
    var upperCaseLetters = /[A-Z]/g;
    if (password.match(upperCaseLetters)) {
      capital.removeClass("txt-danger");
      capital.addClass("txt-success");
    } else {
      capital.removeClass("txt-success");
      capital.addClass("txt-danger");
    }

    // Validate numbers 
    var numbers = /[0-9]/g;
    if (password.match(numbers) && (password.match(lowerCaseLetters) || password.match(upperCaseLetters))) {
      number.removeClass("txt-danger");
      number.addClass("txt-success");
    } else {
      number.removeClass("txt-success");
      number.addClass("txt-danger");
    }

    // Validate length
    if (password.length >= 8) {
      length.removeClass("txt-danger");
      length.addClass("txt-success");
    } else {
      length.removeClass("txt-success");
      length.addClass("txt-danger");
    }

    // Validate special chars
    var format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g;
    if (password.match(format)) {
      char.removeClass("txt-danger");
      char.addClass("txt-success");
    } else {
      char.removeClass("txt-success");
      char.addClass("txt-danger");
    }

    // Validate username match
    if (username == password) {
      usernameMatch.removeClass("txt-success");
      usernameMatch.addClass("txt-danger");
    } else {
      usernameMatch.removeClass("txt-danger");
      usernameMatch.addClass("txt-success");
    }

    if($(".txt-danger").length == 0){
      this.passwordValid = true;
    }else{
      this.passwordValid = false;
    }
    this.proceed = false;
    this.confirmPassword = "";
  }

  setupPassword(){
    if(this.newPassword != this.confirmPassword){
      this.cPassErrMsg = "Confirm password does not match with new password";
    }else{
      this.services.dataStore.setData("password", this.newPassword);
      this.services.router.navigate(['/staging', 'createMPIN']);
    }
  }

}
